import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { BaseContentControlWrapper } from './ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FinishedContainer = ({
  body,
  footer,
  illustration
}) => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      backgroundColor: "fill-surface-default",
      flexDirection: "column",
      justifyContent: "center",
      minBlockSize: "450px",
      padding: "1100",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: [!isTablet && /*#__PURE__*/_jsx(View, {
          marginInline: "1100",
          minInlineSize: "100px",
          children: illustration
        }), body]
      })
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      gap: isMobile ? undefined : '200',
      children: footer
    })]
  });
};
export default FinishedContainer;